<template>
  <div class="product-detail-page">
    <!-- 顶部返回按钮 -->
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang355') }}</span>
    </div>
    <div class="box">
      <div class="box_item">
        <div class="flex">
          <img :src="product.thum" alt="" class="pic" />

          <div class="right">
            <div class="name_box">
              <div class="name">{{ product.name }}</div>
              <div class="font">{{ $t('lang380') + orderlist.length }}</div>
            </div>
            <div class="flex qiu">
              <span>{{ $t('lang381') }}:</span>
              <svg width="24" height="26" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M70,35
             C56,28 38,40 40,54
             C40,64 50,74 70,66"
                  fill="none"
                  stroke="black"
                  stroke-width="6"
                  stroke-linecap="round"
                />
                <line x1="52" y1="29" x2="52" y2="73" stroke="black" stroke-width="5.2" stroke-linecap="round" />
                <line x1="63" y1="29" x2="63" y2="73" stroke="black" stroke-width="5.2" stroke-linecap="round" />
              </svg>
              <span class="qiu_price">{{ product.min_price }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="box_item">
        <div class="title">
          {{ $t('lang368') }}
          <span class="font">{{ $t('lang379') }}</span>
        </div>
        <div class="flex snlist" v-if="orderlist.length > 0">
          <div class="snlist_item" v-for="(item, index) in orderlist" :key="index" :class="[index == orderIndex ? 'snlist_item snlist_item_active' : 'snlist_item']" @click="changeOrder(item, index)">
            {{ item.order_no.substring(0, 3) + '****' + item.order_no.substring(item.order_no.length - 5, item.order_no.length) }}
            <div v-if="index == orderIndex" class="snlist_item_active_tag">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-testid="beast-core-icon-check">
                <path
                  d="M778.748 225.79c16.72-20.641 46.95-23.775 67.523-6.999 20.572 16.776 23.695 47.108 6.975 67.749l-408 503.677c-18.8 23.208-53.912 23.794-73.47 1.227l-200-230.769c-17.395-20.07-15.28-50.49 4.724-67.944 20.005-17.453 50.323-15.33 67.718 4.74l162.538 187.544 371.992-459.226z"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div v-else style="text-align: center">{{ $t('lang378') }}</div>
      </div>
      <div class="box_item">
        <div class="title">{{ $t('lang365') }}</div>
        <div class="flex grey">
          {{ $t('lang363') + '(' + $t('lang362') }}:
          <svg width="24" height="26" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M70,35
             C56,28 38,40 40,54
             C40,64 50,74 70,66"
              fill="none"
              stroke="#535353"
              stroke-width="6"
              stroke-linecap="round"
            />
            <line x1="52" y1="29" x2="52" y2="73" stroke="#535353" stroke-width="5.2" stroke-linecap="round" />
            <line x1="63" y1="29" x2="63" y2="73" stroke="#535353" stroke-width="5.2" stroke-linecap="round" />
          </svg>
          {{ balance || 0 }})
        </div>
      </div>
      <div class="box_item">
        <div class="title">{{ $t('lang366') }}</div>
        <div class="grey yuji">
          <div class="flex sb yuji_item">
            <span>{{ $t('lang382') }}</span>
            <span class="flex">
              <svg width="20" height="26" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M70,35
             C56,28 38,40 40,54
             C40,64 50,74 70,66"
                  fill="none"
                  stroke="#535353"
                  stroke-width="6"
                  stroke-linecap="round"
                />
                <line x1="52" y1="29" x2="52" y2="73" stroke="#535353" stroke-width="5.2" stroke-linecap="round" />
                <line x1="63" y1="29" x2="63" y2="73" stroke="#535353" stroke-width="5.2" stroke-linecap="round" />
              </svg>
              {{ product.min_price || 0 }}
            </span>
          </div>
          <div class="flex sb yuji_item">
            <span>{{ $t('lang367') + '（' + configInfo.serve_fee * 100 + '%）' }}</span>
            <span class="flex" style="color: red">
              <svg width="20" height="26" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M70,35
             C56,28 38,40 40,54
             C40,64 50,74 70,66"
                  fill="none"
                  stroke="red"
                  stroke-width="6"
                  stroke-linecap="round"
                />
                <line x1="52" y1="29" x2="52" y2="73" stroke="red" stroke-width="5.2" stroke-linecap="round" />
                <line x1="63" y1="29" x2="63" y2="73" stroke="red" stroke-width="5.2" stroke-linecap="round" />
              </svg>
              -{{ fee.toFixed(2) || 0 }}
            </span>
          </div>
          <div class="flex sb yuji_item">
            <span>{{ $t('lang366') }}</span>
            <span class="flex">
              <svg width="20" height="26" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M70,35
             C56,28 38,40 40,54
             C40,64 50,74 70,66"
                  fill="none"
                  stroke="#535353"
                  stroke-width="6"
                  stroke-linecap="round"
                />
                <line x1="52" y1="29" x2="52" y2="73" stroke="#535353" stroke-width="5.2" stroke-linecap="round" />
                <line x1="63" y1="29" x2="63" y2="73" stroke="#535353" stroke-width="5.2" stroke-linecap="round" />
              </svg>
              {{ (product.min_price - fee).toFixed(2) || 0 }}
            </span>
          </div>
        </div>
      </div>

      <div class="box_item">
        <div class="title">{{ $t('lang356') }}</div>
        <div class="flex">
          <van-checkbox v-model="checked" class="black" shape="square" checked-color="#29b286" icon-size="16px"
            >{{ $t('lang357') }} <span class="green" @click.stop="blogPopop = true">{{ $t('lang358') }}</span></van-checkbox
          >
        </div>
      </div>
      <div class="box_item">
        <div class="title">{{ $t('lang359') }}</div>
        <div class="flex grey desc" v-html="configInfo.serve_desc"></div>
      </div>
    </div>

    <div class="btn_box flex sb">
      <!-- <div class="btn">{{ $t('lang369') }}</div> -->
      <van-button class="btn" :disabled="!checked" type="primary" @click="submit">{{ $t('lang369') }}</van-button>
    </div>
    <van-overlay :show="loading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="loading" />
      </div>
    </van-overlay>
    <van-popup v-model="blogPopop" round position="bottom">
      <div class="blogModel">
        <div class="title"></div>
        <van-icon name="cross" class="close" size="20" @click="blogPopop = false" />
        <div class="body" v-html="blogData.body"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { homeApi } from '@/api/index';
import { Dialog, Notify, Toast } from 'vant';
export default {
  data() {
    return {
      loading: false,
      submitPopop: false,
      number: 1,
      product: {},
      type: 0, // 1确认订单  2以求购价售出  3发起求购
      checked: false,
      qiuNumber: 1,
      qiuPrice: '',
      maxPrice: 0,
      configInfo: {
        lock_time: 0,
        min_buy_price: 0,
        serve_desc: '',
        serve_fee: 0,
        max_buying_count: 0,
        zh_serve_agree: '',
        en_serve_agree: '',
      },
      orderlist: [],
      orderIndex: 0,
      fee: 0,
      balance: 0,
      blogPopop: false,
      blogData: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getBuyingDetail(this.$route.query.buying);
      this.getUserInfo();
      this.getHoldProductOrderList(this.$route.query.product_id);
    },
    back() {
      this.$router.back();
    },
    changeOrder(item, index) {
      this.orderIndex = index;
    },
    getBuyingDetail(buying_id) {
      homeApi.getBuyingDetail({ buying_id }).then(res => {
        if (res.code == 200) {
          this.product = res.data;
          this.getMarketConfig();
        } else {
        }
      });
    },
    getMarketConfig() {
      homeApi.getMarketConfig({}).then(res => {
        if (res.code == 200) {
          this.configInfo = res.data;
          this.fee = this.configInfo.serve_fee * this.product.min_price;
          this.getAnnouncementDetail();
        } else {
        }
      });
    },
    getHoldProductOrderList(product_id) {
      homeApi.getHoldProductOrderList({ product_id }).then(res => {
        if (res.code == 200) {
          this.orderlist = res.data;
        } else {
        }
      });
    },
    getUserInfo() {
      homeApi.getUserInfo({}).then(res => {
        if (res.code == 200) {
          this.balance = res.data.balance;
        } else {
        }
      });
    },
    submit() {
      let _this = this;
      if (this.orderlist.length <= 0) {
        return Toast({ message: _this.$t('lang406') });
      }
      let params = {
        buying_id: this.$route.query.buying,
        order_id: this.orderlist[this.orderIndex].id,
      };
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang374'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          this.loading = true;
          homeApi.sellBuying(params).then(res => {
            if (res.code == 200) {
              _this.loading = false;
              Toast({ message: _this.$t('lang375') });
              _this.$router.back();
            } else if (res.code == 15001) {
              _this.loading = false;
              setTimeout(() => {
                _this.$router.push('recharge');
              }, 300);
            } else {
              _this.loading = false;
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    navigatorTo(name, id) {
      if (name == 'service') {
        console.log(this.$i18n.locale);
        if (this.$i18n.locale == 'zh-cn') {
          this.$router.push({ name, query: { id: this.configInfo.zh_serve_agree } });
        } else if (this.$i18n.locale == 'en') {
          this.$router.push({ name, query: { id: this.configInfo.en_serve_agree } });
        }
      } else {
        this.$router.push({ name, query: { id: id } });
      }
    },
    getAnnouncementDetail() {
      if (this.$i18n.locale == 'zh-cn') {
        let params = {
          id: this.configInfo.zh_serve_agree,
        };
        homeApi.getAnnouncementDetail(params).then(res => {
          if (res.code == 200) {
            this.blogData = res.data;
          }
        });
      } else if (this.$i18n.locale == 'en') {
        let params = {
          id: this.configInfo.en_serve_agree,
        };
        homeApi.getAnnouncementDetail(params).then(res => {
          if (res.code == 200) {
            this.blogData = res.data;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.box {
  width: 100%;
  // height: 100vh;
  color: #000;
  font-size: 13px;
  padding: 64px 14px 120px;
  box-sizing: border-box;
  //   background-color: #fff;
  .grey {
    color: #535353;
  }
  .black {
    color: #000;
  }
  .grey-8 {
    color: #535353;
  }

  &_item {
    font-size: 12px;
    letter-spacing: 1px;
    padding: 10px;
    border-radius: 12px;
    margin-bottom: 10px;
    background-color: #fff;
    .pic {
      width: 80px;
      height: 80px;
      border-radius: 8px;
    }

    .right {
      padding-left: 14px;
      .name_box {
        color: #808080;
        font-size: 13px;

        .name {
          color: #000;
          font-size: 16px;
          font-weight: 600;
          line-height: 160%;
        }
      }
      .qiu {
        padding-top: 8px;
        &_price {
          font-size: 17px;
          font-weight: 600;
          margin-left: -2px;
          margin-top: -3px;
        }
      }
    }
    .title {
      font-size: 14px;
      font-weight: 600;
      line-height: 160%;
      padding-bottom: 8px;
    }
    .price {
      font-size: 13px;
      font-weight: 600;
      margin-left: -2px;
    }
    .green {
      color: #29b286;
    }
    .van-checkbox {
      padding-top: 6px;
    }
    .desc {
      font-size: 11px;
      line-height: 150%;
      padding-top: 3px;
    }
    .yuji {
      width: 100%;
      // padding-top: 8px;
    }
    .font {
      color: #808080;
      font-size: 11px;
    }
    .snlist {
      flex-wrap: wrap;
      // justify-content: space-around;
      justify-content: flex-start;
      gap: 10px; /* 横向和纵向间距 */
      padding-top: 8px;
      &_item {
        font-size: 11px;
        text-align: center;
        padding: 4px 6px;
        border-radius: 4px;
        // margin: 0 10px 10px 0;
        width: calc((100% - 20px) / 3); /* 3列，减去两个gap */
        background-color: #f5f5f5;
      }
      .snlist_item_active {
        position: relative;
        color: #29b286;
        background-color: #cfe9e0;
        svg {
          position: absolute;
          bottom: -6px;
          right: -7px;
          font-size: 1px;
          width: 8px;
          z-index: 100;
          fill: #fff;
        }
      }
      .snlist_item_active_tag {
        bottom: 0px;
        right: 0px;
        width: 0;
        height: 0;
        z-index: 9;
        position: absolute;
        border-width: 8px 8px;
        border-color: rgba(0, 0, 0, 0) #29b286 #29b286 rgba(0, 0, 0, 0);
        border-style: solid;
        border-radius: 4px;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
    }
    .reflash {
      font-size: 10px;
      color: #000;
      width: calc(100vw - 150px);
      padding: 8px;
      border-radius: 6px;
      margin-top: 8px;
      background-color: #f5f5f5;

      &_price {
        font-size: 16px;
        font-weight: 600;
        margin-left: -6px;
      }
    }
    .pt {
      padding-top: 10px;
    }
    /deep/ .van-checkbox__icon .van-icon {
      border-radius: 2px;
      border-color: #29b286 !important;
    }
    /deep/.van-stepper__input {
      background-color: #fff;
    }
    /deep/.van-stepper__plus,
    /deep/.van-stepper__minus {
      transform: scale(0.9);
      border-radius: 50%;
    }
    /deep/.van-field {
      font-size: 18px;
      font-weight: 600;
      margin-left: -10px;
    }
    /deep/.van-field__control::placeholder {
      font-size: 15px;
      font-weight: normal;
    }
    /deep/.van-field__control::-webkit-input-placeholder {
      font-size: 15px;
      font-weight: normal;
    }
    /deep/.van-field__control::-moz-placeholder {
      font-size: 15px;
      font-weight: normal;
    }
    /deep/.van-field__control::-ms-input-placeholder {
      font-size: 15px;
      font-weight: normal;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
}
.sb {
  justify-content: space-between;
}
.bottom {
  padding: 14px 14px;
  background-color: #fff;

  /deep/.van-tab {
    flex: none;
    font-weight: 600;
    color: #c5c5c5;
    font-size: 13px;
    letter-spacing: 0.5px;
    margin-right: 10px;
  }

  /deep/.van-tabs__nav--line {
    padding-bottom: 10px;
  }
}
.warn {
  position: fixed;
  bottom: 75px;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 4px 0;
  font-size: 11px;
  color: #fc9611;
  font-weight: 600;

  background-color: #f8efe0;
}
.btn_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 75px;
  padding: 16px 20px;
  border-top: 1px solid rgba(#c7c7c7, 0.3);
  background-color: #fff;
  .btn {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    color: #fff;
    font-size: 15px;
    text-align: center;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 12px 10px;
    border-radius: 22px;
    border: none;
    background-color: #29b286;
  }
  .submit {
    width: 58%;
    background-color: #17ab79;
  }
  .left {
    color: #000;
    font-size: 14px;
    flex-direction: column;
    .price {
      font-size: 18px;
      font-weight: 600;
      margin-left: -10px;
      // margin-top: -3px;
    }
    .font {
      font-size: 12px;
    }
  }
}

.blogModel {
  color: #000;
  font-size: 15px;
  .close {
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .title {
    padding: 20px 20px 26px;
    text-align: center;
  }
  .body {
    max-height: 60vh;
    min-height: 50vh;
    overflow: auto;
    padding: 0 14px 20px;
  }
}
/deep/.van-button--disabled {
  opacity: 0.6;
}
.wrapper {
  // display: flex;
  // justify-content: center;
  .loading {
    position: absolute;
    left: 46%;
    top: 46%;
  }
}
</style>
      
      